module.exports = __webpack_public_path__ + "img/Meloni.f0be0c9e.jpg";